import { useCallback } from "react"

import { useSettings } from "../modules/settings"

// Single accessor for the sidebar visibility toggle. Visibility lives in
// `useSettings().isVisible` so it survives navigation/remounts and the shell's
// auto-hide rules (route change, mobile blur) all write to the same state. Use
// this hook instead of reaching into the settings internals directly.
export function useSidebar() {
  const { isVisible, setIsVisible } = useSettings()
  const closeSidebar = useCallback(()=> {
    setIsVisible(false)
  }, [setIsVisible])
  const showSidebar = useCallback(()=> {
    setIsVisible(true)
  }, [setIsVisible])
  const toggleSidebar = useCallback(()=> {
    setIsVisible(!isVisible)
  }, [isVisible, setIsVisible])
  return { closeSidebar, isVisible, setIsVisible, showSidebar, toggleSidebar }
}
